import { render, staticRenderFns } from "./DeviceShipments.vue?vue&type=template&id=6774bb40&scoped=true"
import script from "./DeviceShipments.vue?vue&type=script&lang=js"
export * from "./DeviceShipments.vue?vue&type=script&lang=js"
import style0 from "./DeviceShipments.vue?vue&type=style&index=0&id=6774bb40&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774bb40",
  null
  
)

export default component.exports